exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-divider__divider{height:1px;padding:0;border-top:1px solid rgba(0,0,0,.4)}.nil-sa-elements-divider__divider .nil-sa-elements-divider__name{vertical-align:middle;display:inline-block;padding:0 24px}", ""]);

// exports
exports.locals = {
	"divider": "nil-sa-elements-divider__divider",
	"name": "nil-sa-elements-divider__name"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/Divider/index.less
// module id = 207
// module chunks = 0